import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast, Toaster } from 'sonner';

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const r = await login(username.trim().toLowerCase(), password);
            toast.success(`Welcome, ${r.user.username}`);
            const dest = loc.state?.from?.pathname || (r.user.role === 'admin' ? '/admin' : '/');
            nav(dest, { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Login failed');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-ink text-white grid md:grid-cols-2">
            <Toaster theme="dark" />
            <div className="hidden md:block relative overflow-hidden">
                <img
                    src="https://images.unsplash.com/photo-1564415315949-7a0c4c73aab4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                    alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-br from-ink via-ink/80 to-[#0b1a02]/80" />
                <div className="absolute inset-0 grain" />
                <div className="relative z-10 h-full flex flex-col justify-between p-12">
                    <div className="flex items-center gap-3">
                        <img
                            src="https://customer-assets.emergentagent.com/job_locals-academy-gear/artifacts/lyqjkjl7_LJJ-Logo-01-Black.png"
                            alt="Locals Jiu Jitsu"
                            className="h-14 w-14 object-contain"
                            style={{ filter: 'invert(1) brightness(1.1)' }}
                        />
                        <div>
                            <div className="font-display text-2xl uppercase tracking-tighter">Locals HQ</div>
                            <div className="font-mono-data text-xs text-zinc-400 uppercase">Apparel Portal</div>
                        </div>
                    </div>
                    <div>
                        <h1 className="font-display text-6xl uppercase tracking-tighter leading-none mb-4">
                            Order<br/>Like a <span className="text-crimson">Pro.</span>
                        </h1>
                        <p className="font-body text-zinc-300 max-w-md">
                            Wholesale gear for every Locals academy. Gi, rashguards, belts, tees and tatami mats —
                            fulfilled direct by Locals Headquarters.
                        </p>
                    </div>
                    <div className="font-mono-data text-xs text-zinc-500 uppercase">
                        Locals Jiu Jitsu · Franchise Network · AU
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
                    <div className="font-mono-data text-xs uppercase text-crimson tracking-widest mb-3">
                        Academy Access
                    </div>
                    <h2 className="font-display text-4xl uppercase tracking-tighter mb-8">Sign in</h2>

                    <label className="block mb-5">
                        <div className="font-mono-data text-xs uppercase text-zinc-400 mb-2">Username</div>
                        <input
                            data-testid="login-username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            placeholder="zetland / maroubra / hq"
                            className="w-full bg-surface border border-zinc-800 px-4 py-3 text-white placeholder-zinc-600"
                        />
                    </label>

                    <label className="block mb-8">
                        <div className="font-mono-data text-xs uppercase text-zinc-400 mb-2">Password</div>
                        <input
                            data-testid="login-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full bg-surface border border-zinc-800 px-4 py-3 text-white"
                        />
                    </label>

                    <button
                        data-testid="login-submit"
                        type="submit"
                        disabled={busy}
                        className="w-full bg-brand hover:bg-brand-hover text-black font-display uppercase tracking-wider py-3 transition-colors disabled:opacity-50"
                    >
                        {busy ? 'Signing in…' : 'Enter Portal'}
                    </button>

                    <div className="mt-10 p-4 border border-zinc-800 bg-surface/40">
                        <div className="font-mono-data text-[10px] uppercase text-zinc-500 mb-2">Demo Logins</div>
                        <div className="font-mono-data text-xs text-zinc-300 space-y-1">
                            <div>hq / locals2026  <span className="text-crimson">→ HQ admin</span></div>
                            <div>zetland / locals2026</div>
                            <div>maroubra / locals2026</div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
